import * as R from "ramda";
import React, { Component } from "react";

import { TextField, SimpleShowLayout } from "react-admin";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";

const styles = {
  container: { minWidth: "35em", marginLeft: "1em", marginBottom: "1em" },
  rightAlignedCell: { textAlign: "center" },
  inlineField: {
    display: "inline-block",
    width: "50%"
  }
};

class CustomizedParameters extends Component {
  getValuePath(type, name) {
    if (type.endsWith("Plain")) {
      return `${type}.${name}`;
    }

    return `${type}.${name}.val`;
  }

  render() {
    const { classes, record } = this.props;
    const { customizedParameters } = record;
    if (!customizedParameters) {
      return null;
    }
    let type;
    const emsPlain = R.propOr(null, ["emsPlain"], customizedParameters);
    const ems = R.propOr(null, ["ems"], customizedParameters);
    const tensPlain = R.propOr(null, ["tensPlain"], customizedParameters);
    const tens = R.propOr(null, ["tens"], customizedParameters);
    if (emsPlain) {
      type = "emsPlain";
    }
    if (ems) {
      type = "ems";
    }
    if (tensPlain) {
      type = "tensPlain";
    }
    if (tens) {
      type = "tens";
    }

    return (
      <Paper className={classes.container}>
        <CardContent>
          <Typography className={classes.rightAlignedCell} variant="subheading">
            Customizable Parameters ({type}):
          </Typography>
          {type.startsWith("ems") && (
            <SimpleShowLayout record={customizedParameters}>
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Contraction
              </Typography>
              <TextField
                label="Frequency (hz):"
                source={this.getValuePath(type, "cFreq")}
                className={classes.inlineField}
              />
              <TextField
                label="Total Duration (seconds):"
                source={this.getValuePath(type, "cSecs")}
                className={classes.inlineField}
              />
              <TextField
                label="Pulse Width (us):"
                source={this.getValuePath(type, "pulseW")}
                className={classes.inlineField}
              />
              {R.pathOr(null, [type, "intShift"], customizedParameters) && (
                <TextField
                  label="Intensity Shift (optional):"
                  className={classes.inlineField}
                  source={`${type}.intShift`}
                />
              )}
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Rest
              </Typography>
              <TextField
                label="Rest Frequency (hz):"
                className={classes.inlineField}
                source={this.getValuePath(type, "rFreq")}
              />
              <TextField
                label="Rest (seconds):"
                className={classes.inlineField}
                source={this.getValuePath(type, "rSecs")}
              />
              {R.pathOr(null, [type, "restInt"], customizedParameters) && (
                <TextField
                  label="Rest Intensity (optional):"
                  className={classes.inlineField}
                  source={`${type}.restInt`}
                />
              )}
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Ramp
              </Typography>
              <TextField
                label="Up (seconds):"
                className={classes.inlineField}
                source={this.getValuePath(type, "rampU")}
              />
              <TextField
                label="Down (seconds):"
                className={classes.inlineField}
                source={this.getValuePath(type, "rampD")}
              />
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Duration
              </Typography>

              {R.pathOr(
                null,
                [type, "duration", "cCount"],
                customizedParameters
              ) && (
                <TextField
                  className={classes.inlineField}
                  label="Total:"
                  source={this.getValuePath(type, "duration.cCount")}
                  allowEmpty={false}
                />
              )}
              {R.pathOr(
                null,
                [type, "duration", "secs"],
                customizedParameters
              ) && (
                <TextField
                  label="Total Time (seconds):"
                  className={classes.inlineField}
                  source={this.getValuePath(type, "duration.secs")}
                  allowEmpty={false}
                />
              )}
            </SimpleShowLayout>
          )}
          {type.startsWith("tens") && (
            <SimpleShowLayout record={customizedParameters}>
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Contraction
              </Typography>
              <TextField
                label="Frequency (hz):"
                source={this.getValuePath(type, "freq")}
                className={classes.inlineField}
              />
              <TextField
                label="Frequency Modulation:"
                source={this.getValuePath(type, "freqMod")}
                className={classes.inlineField}
              />
              <TextField
                label="Total Duration (seconds):"
                source={this.getValuePath(type, "durSecs")}
                className={classes.inlineField}
              />
              <TextField
                label="Modulation Time (seconds):"
                source={this.getValuePath(type, "modTime")}
                className={classes.inlineField}
              />
              {R.pathOr(null, [type, "intShift"], customizedParameters) && (
                <TextField
                  label="Intensity Shift (optional):"
                  className={classes.inlineField}
                  source={`${type}.intShift`}
                />
              )}
              <TextField
                label="Pulse Width (us):"
                source={this.getValuePath(type, "pulseW")}
                className={classes.inlineField}
              />
              <TextField
                label="Pulse Width Modulation (us):"
                source={this.getValuePath(type, "pulseWMod")}
                className={classes.inlineField}
              />
              <TextField
                label="Burst Interval:"
                source={this.getValuePath(type, "bInterval")}
                className={classes.inlineField}
              />
              <TextField
                label="Burst Pulses:"
                source={this.getValuePath(type, "bPulses")}
                className={classes.inlineField}
              />
              <Typography variant="body1" className={classes.rightAlignedCell}>
                Miscellaneous
              </Typography>
              <TextField
                label="Interphase Interval:"
                source={this.getValuePath(type, "iInterval")}
                className={classes.inlineField}
              />
            </SimpleShowLayout>
          )}
        </CardContent>
      </Paper>
    );
  }
}

export default withStyles(styles)(CustomizedParameters);
